(function () {
  'use strict';

  function initGallery(section) {
    if (!section || section.dataset.jbGallerySwipeReady === 'true') return;

    var imageWrap = section.querySelector('.jb-product__main-img-wrap');
    var thumbs = section.querySelector('.jb-product__thumbs');
    if (!imageWrap || !thumbs) return;

    var thumbButtons = Array.prototype.slice.call(thumbs.querySelectorAll('.jb-product__thumb'));
    if (thumbButtons.length < 2) return;

    section.dataset.jbGallerySwipeReady = 'true';

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var ignoreClickUntil = 0;
    var swipeDistance = 44;
    var directionBias = 1.2;

    function resetGesture() {
      tracking = false;
      startX = 0;
      startY = 0;
    }

    function activeIndex() {
      var active = thumbs.querySelector('.jb-product__thumb.is-active');
      var index = thumbButtons.indexOf(active);
      return index < 0 ? 0 : index;
    }

    function centreThumb(button) {
      if (!button || thumbs.scrollWidth <= thumbs.clientWidth) return;

      var nextLeft = button.offsetLeft - (thumbs.clientWidth - button.offsetWidth) / 2;
      thumbs.scrollTo({
        left: Math.max(0, nextLeft),
        behavior: 'smooth'
      });
    }

    function showAdjacentImage(direction) {
      var currentIndex = activeIndex();
      var nextIndex = Math.max(0, Math.min(thumbButtons.length - 1, currentIndex + direction));
      if (nextIndex === currentIndex) return;

      var nextButton = thumbButtons[nextIndex];
      nextButton.click();
      centreThumb(nextButton);
    }

    imageWrap.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) {
        resetGesture();
        return;
      }

      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    imageWrap.addEventListener('touchend', function (event) {
      if (!tracking || event.changedTouches.length !== 1) {
        resetGesture();
        return;
      }

      var distanceX = event.changedTouches[0].clientX - startX;
      var distanceY = event.changedTouches[0].clientY - startY;
      var isHorizontalSwipe = Math.abs(distanceX) >= swipeDistance &&
        Math.abs(distanceX) > Math.abs(distanceY) * directionBias;

      resetGesture();
      if (!isHorizontalSwipe) return;

      ignoreClickUntil = Date.now() + 450;
      if (event.cancelable) event.preventDefault();
      showAdjacentImage(distanceX < 0 ? 1 : -1);
    }, { passive: false });

    imageWrap.addEventListener('touchcancel', resetGesture, { passive: true });

    imageWrap.addEventListener('click', function (event) {
      if (Date.now() >= ignoreClickUntil) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  }

  function initGalleries(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('.jb-product-section')) {
      initGallery(scope);
    }

    scope.querySelectorAll('.jb-product-section').forEach(initGallery);
  }

  if (window.JellybeanProductGallerySwipe) {
    window.JellybeanProductGallerySwipe.init(document);
    return;
  }

  window.JellybeanProductGallerySwipe = { init: initGalleries };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initGalleries(document);
    });
  } else {
    initGalleries(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initGalleries(event.target);
  });
})();
